import React from 'react';
import { useUI } from '../../contexts/UIContext';

const LoadingOverlay = () => {
  const { loadingMessage } = useUI();

  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <div className="spinner-circles"></div>
      </div>
      <div className="loading-text">{loadingMessage}</div>
    </div>
  );
};

export default LoadingOverlay;
